import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import ItemActions from "./TableItemActions";

export default function Table({
  teamId,
  collection,
  updateCollection,
  editData,
  showMembers,
}) {
  const columns = [
    {
      name: "Cycle",
      selector: "attributes.title",
      sortable: true,
    },
    {
      name: "Start Date",
      selector: "attributes.format_cycle_start",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.cycle_start_int - b.attributes.cycle_start_int,
    },
    {
      name: "End Date",
      selector: "attributes.format_cycle_end",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.cycle_end_int - b.attributes.cycle_end_int,
    },
    {
      name: "Grace Period",
      selector: "attributes.grace_period",
      sortable: true,
    },
    {
      name: "Current",
      selector: "attributes.current",
      sortable: true,
    },
    {
      name: "Members",
      selector: "attributes.count_members",
      sortable: true,
    },
    {
      name: "Terminated",
      selector: "attributes.count_terminated",
      sortable: true,
    },
    {
      name: "Actions",
      width: "200px",
      cell: (row) => <div></div>,
      sortable: false,
      cell: (row) => (
        <ItemActions
          row={row}
          teamId={teamId}
          updateCollection={updateCollection}
          editData={editData}
          showMembers={showMembers}
        />
      ),
    },
  ];

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={collection}
        noDataComponent="No records"
        persistTableHead={true}
      />
    </div>
  );
}
